import { data } from "autoprefixer";
import axios from "axios";
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";

// components

export default function CardProductGroup() {
  const [datas, setDatas] = useState("");
  const [addData, setAddData] = useState("");
  const [pending, setPending] = useState(true);
  const [showModal, setShowModal] = useState(false);
  //fetch data from api category
  useEffect(() => {
    axios.get(`http://${process.env.REACT_APP_API_URL}/utility/search-product-group`, {
      headers: {
        Bearer: localStorage.getItem('token')
      }
    }).then((response) => {
      // console.log(response);
      if (response.status === 200) {
        setDatas(response.data);
        setPending(false);
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      console.log(error);
      // console.log(error.response.data.message);
    });

  }, [])



  const columns = [

    {
      name: 'Code',
      selector: row => row.productGroupCode,
      maxWidth: '100px'
    },
    {
      name: 'ชื่อกลุ่มสินค้า',
      // selector: row => row.unitName,
      cell: row => <p>{row.productGroupName}</p>,
    },
    {
      name: 'สร้างโดย',
      selector: row => {
        return <>
          <p className="text-center">{row.createBy}</p>
          <br />
          <p>{new Date(row.createDate).toLocaleDateString("th")}</p>
        </>
      },
      maxWidth: '200px'
    },
    {
      name: 'อัพเดทโดย',
      selector: row => {
        return <>
          <p className="text-center">{row.updateBy}</p>
          <br />
          <p>{new Date(row.updateDate).toLocaleDateString("th")}</p>
        </>
      },
      maxWidth: '200px'
    },

    // {
    //   name: 'Edit',
    //   button: true,
    //   cell: (row) => <button onClick={() => window.location.href = "/product/update/" + row.productCode}><i className="mr-2 text-sm fas fa-pen" /></button>,
    // },
    {
      name: 'Delete',
      button: true,
      cell: (row) => <button onClick={() => handleDelete(row)}><i className="mr-2 text-sm fas fa-trash" /></button>,

    },
  ];

  const customStyles = {
    table: {
      style: {
        borderRadius: "20px",
      },
    },
    rows: {
      style: {
        minHeight: '72px',
        // override the row height
        '&:hover': {
          // cursor: 'pointer',
          backgroundColor: "#B4BDFF",

        },
      },
    },
    expanderCell: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
        backgroundColor: "#83A2FF",

      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
        backgroundColor: "#83A2FF",

      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',

      },

    },

  };

  const handleAddData = (e) => {
    setAddData({ ...addData, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    console.log(1234);
    e.preventDefault();

    axios.post(`http://${process.env.REACT_APP_API_URL}/utility/save`, addData, {
      headers: {
        Bearer: localStorage.getItem('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      console.log(response);
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          text: 'Success!',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          window.location.href = "/admin/settings";
        }
        )
      }
    }
    ).catch((error) => {
      if (error.response.data.status === 401) {
        window.location.href = "/auth/login";
      }
      // Swal.fire("SweetAlert2 is working!");

      // console.log(error);
      console.log(error.response.data.message);
    });
  };

  const handleDelete = (row) => {
    const productGroupCode = { isDelete: 1, productGroupCode: row.productGroupCode }
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(`http://${process.env.REACT_APP_API_URL}/utility/save`, productGroupCode, {
          headers: {
            Bearer: localStorage.getItem('token')
          }
        }).then((response) => {
          // console.log(response);
          if (response.status === 200) {
            Swal.fire({
              title: "Deleted!",
              text: "deleted.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
            }).then(() => {
              window.location.reload();
            }
            );
           
            //  window.location.href = "/product";
          }
        }
        ).catch((error) => {
          if (error.response.data.status === 401) {
            window.location.href = "/auth/login";
          }
          //  console.log(error);
          console.log(error.response.data.message);
        });
      }
    });
  }
  return (
    <>
      <div className="relative flex flex-col w-full min-w-0 mt-10 mb-6 break-words border-0 rounded-lg shadow-lg bg-blueGray-100">
        <div className="px-6 py-6 mb-0 bg-white rounded-t">
          <div className="flex justify-between text-center">
            <h6 className="text-xl font-bold text-blueGray-700">เมนูกลุ่มสินค้า</h6>
            <button
              className="px-4 py-2 mr-1 text-xs font-bold text-white uppercase transition-all duration-150 ease-linear rounded shadow outline-none bg-lightBlue-500 active:bg-lightBlue-600 hover:shadow-md focus:outline-none"
              type="button"
              onClick={() => setShowModal(true)}
            >
              Add
            </button>
          </div>
        </div>
        {showModal && <>
          <div
            className="absolute inset-0 z-50 flex items-center justify-center w-full h-full overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          // className="fixed inset-0 flex items-center justify-center w-full h-full overflow-x-hidden overflow-y-auto outline-none focus:outline-none"
          // onClick={() => setShowModal(false)}
          >
            <div className="relative w-4/12 mx-auto my-6 " style={{ width: "500px", marginLeft: "300px" }}>
              {/*content*/}
              <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-blueGray-200">
                  <h3 className="text-3xl font-semibold">
                    เพิ่มกลุ่มสินค้า
                  </h3>
                  <button
                    className="float-right p-1 ml-auto text-3xl font-semibold leading-none text-black bg-transparent border-0 outline-none opacity-5 focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="block w-6 h-6 text-2xl text-black bg-transparent outline-none opacity-5 focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative flex-auto p-6">
                  <div className="grid mb-6 -mx-3">
                      <div className="flex p-5">
                        <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                          <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                            รหัส
                          </label>
                          <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                            id="productGroupCode" name="productGroupCode" type="text" onChange={handleAddData} value={datas.productGroupCode} />
                        </div>
                        <div className="w-full px-3 mb-3 md:mb-0" style={{ width: "300px" }}>
                          <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" >
                            ชื่อกลุ่มสินค้า
                          </label>
                          <input className="block w-full px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                            id="productGroupName" name="productGroupName" type="text" onChange={handleAddData} value={datas.productGroupName} />
                        </div>
                      </div>
                  </div>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid rounded-b border-blueGray-200">
                  <button
                    className="px-6 py-2 mb-1 mr-1 text-sm font-bold text-red-500 uppercase transition-all duration-150 ease-linear outline-none background-transparent focus:outline-none"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                  <button
                    className="px-6 py-3 mb-1 mr-1 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear rounded shadow outline-none bg-emerald-500 active:bg-emerald-600 hover:shadow-lg focus:outline-none"
                    type="button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>}
        <div style={{ margin: "20px" }} className="block overflow-x-auto rounded-lg ">
          <DataTable
            data={datas}
            columns={columns}
            customStyles={customStyles}
            pagination
            progressPending={pending}
          >

          </DataTable>

        </div>
      </div>
    </>
  );
}
